import React, { Component } from 'react'
import styled, { css } from 'styled-components'

import { colors, media } from '../utils/style-utils'
import logoImg from '../img/mini-logo-white.svg'
import menuCloseIcon from '../img/menu-close.svg'
import { TweenMax, ScrollToPlugin, Strong } from 'gsap'

const Offcanvas = styled.section`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  pointer-events: none;
  opacity: 0;
  transition: opacity 400ms;
  transition-delay: 400ms;

  ${props =>
    props.isOpen &&
    css`
      transition-delay: 0ms;
      pointer-events: all;
      opacity: 1;
      .offcanvas__main {
        transform: translateX(0%);
      }
    `};
`

const OffcanvasSection = styled.div`
  position: absolute;
  top: 0;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: 400ms 80ms;
  transition-timing-function: cubic-bezier(0.01, 0.35, 0, 0.97);
  width: 100%;
  padding: 3rem 1rem;
  ${media.tablet`
    padding: 3rem 5rem;
  `};
  ${media.tablet`
    width: 75%;
  `};

  ${media.desktop`
    width: 50%;
  `};

  ${props =>
    props.main &&
    css`
      background: ${colors.black};
      transform: translateX(100%);
      right: 0;
    `};

  ${props =>
    props.side &&
    css`
      && {
        width: 100%;
      }
      left: 0;
      opacity: 0.8;
      background: ${colors.white};
    `};
`
const OffcanvasMenu = styled.nav`
  overflow: hidden;
  color: ${colors.white};
  font-weight: 300;
  font-size: 18px;
  letter-spacing: 0.08em;
  line-height: 1.2;
  -webkit-font-smoothing: antialiased;
  text-transform: uppercase;

  li {
    display: block;
    margin: 1em 0;
    ${media.tablet`margin: 3em 0;`};
  }

  a {
    color: inherit;
    text-decoration: inherit;
  }
`

const MenuIndex = styled.span`
  display: block;
`
const MenuLabel = styled.span`
  font-weight: bold;
  ${media.tablet`display: block;`};
`

const MenuClose = styled.button`
  position: absolute;
  z-index: 500;
  right: 20px;
  top: 20px;
  background: none;
  appearance: none;
  border: 0;
  border-radius: 0;
  cursor: pointer;
  &:focus {
    outline: none;
  }
`

const Logo = styled.img`
  display: none;
  ${media.tablet`display: block;`};
`

class Menu extends Component {
  handleMenuItemClick(e) {
    e.preventDefault()
    const anchor = '#' + e.currentTarget.href.split('#').pop()
    this.props.onCloseClick()
    TweenMax.to(window, 1, { scrollTo: anchor, ease: Strong.easeInOut })
  }
  render() {
    const { isOpen, onCloseClick, menuLabels } = this.props
    console.log(menuLabels)
    const menuItems = [
      { name: menuLabels.menu_case, href: '#about' },
      { name: menuLabels.menu_products, href: '#products' },
      { name: menuLabels.menu_maintenance, href: '#maintenance' },
      { name: menuLabels.menu_remove_stains, href: '#filter' },
      { name: menuLabels.menu_contact_us, href: '#contact' },
    ]
    return (
      <Offcanvas className="offcanvas" isOpen={isOpen}>
        <MenuClose onClick={onCloseClick}>
          <img src={menuCloseIcon} alt="Close menu" />
        </MenuClose>
        <OffcanvasSection side="true" className="side" />
        <OffcanvasSection className="offcanvas__main" main="true">
          <Logo src={logoImg} alt="Thibault Van Renne" />
          <OffcanvasMenu>
            <ul>
              {menuItems.map((item, index) => (
                <li key={item.name}>
                  <a
                    onClick={this.handleMenuItemClick.bind(this)}
                    href={item.href}
                  >
                    <MenuIndex>0{index + 1}—</MenuIndex>
                    <MenuLabel>
                      {item.name
                        .split(' ')
                        .map(word => (
                          <MenuLabel key={item.href + word}>{word} </MenuLabel>
                        ))}
                    </MenuLabel>
                  </a>
                </li>
              ))}
            </ul>
          </OffcanvasMenu>
        </OffcanvasSection>
      </Offcanvas>
    )
  }
}

export default Menu



// WEBPACK FOOTER //
// ./src/components/Menu.js